import React, { useState } from 'react';
import classNames from 'classnames';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './CustomExtendedDataSection.module.css';
import { FormattedMessage } from '../../util/reactIntl';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const MAX_BRIEF_TEXT_LENGTH = 500;

const SectionText = props => {
  const [showFullText, setShowFullText] = useState( false );
  const {
    text,
    heading,
    headingClassName,
    className,
    rootClassName,
    showAsIngress = false,
  } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const visibleText = showFullText || text.length <= MAX_BRIEF_TEXT_LENGTH
    ? text
    : text.substring( 0, MAX_BRIEF_TEXT_LENGTH ) + '...';
  const content = richText(visibleText, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  const classes = classNames(rootClassName || css.sectionText, className);

  return visibleText ? (
    <section className={classes}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading} className={headingClassName}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
      { text.length > MAX_BRIEF_TEXT_LENGTH
        ? showFullText
          ? (
              <span
                className={css.showMoreLess}
                onClick={() => setShowFullText( false )}
              >
                <FormattedMessage id="SectionText.showLess" />
              </span>
            )
          : (
              <span
                className={css.showMoreLess}
                onClick={() => setShowFullText( true )}
              >
                <FormattedMessage id="SectionText.showMore" />
              </span>
            )
        : null }
    </section>
  ) : null;
};

export default SectionText;
